const showOrHideElements = {
  auth: {
    signIn: {
      howDoesOptimiseWorkLink: true,
      showCompanyLogoInCard: false,
    },
    signUp: {
      howDoesOptimiseWorkLink: true,
      showCompanyLogoInCard: false,
      showMainNavOnLogin: false,
    },
  },
  onBoarding: {
    showMainNav: false,
    showCompanyLogoInCard: false,
  },
};

export default showOrHideElements;
